import React from 'react';

import { SidebarEventTypes, track } from '~/src/dash/analytics/analytics';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { IExtendedPermission, IPermissionCheck } from '~/src/dash/utils/permission_service';
import { hasRoleSuperUser } from '~/src/dash/utils/roles';
import { RESELLERIDS } from '~/src/dash/utils/ui';

export const getMenuBackgroundColor = (
  isHover: boolean,
  isActive: boolean,
  theme: Record<string, string>,
) => {
  switch (true) {
    case isHover:
      return theme.menuBarHovered;
    case isActive:
      return theme.menuBarSelected;
    default:
      return 'inherit';
  }
};

export const getNavWidth = (isNavExpanded: boolean, isScrollbarVisible: boolean) => {
  switch (true) {
    case isNavExpanded && !isScrollbarVisible:
      return '220px';
    case isNavExpanded && isScrollbarVisible:
      return '237px';
    case !isNavExpanded && !isScrollbarVisible:
      return '64px';
    case !isNavExpanded && isScrollbarVisible:
    default:
      return '81px';
  }
};

// TODO: if time, refactor this older function to be more intuitive
export const missingPermToText = (permResult: IPermissionCheck): React.ReactNode => {
  if (permResult.isAuthorized) {
    return undefined as React.ReactNode;
  }
  return (
    <div>
      Missing one of these permissions:
      {permResult.missingPermissions.map((perm: IExtendedPermission) => {
        return (
          <div>
            -{perm.description} ({perm.name})
          </div>
        );
      })}
    </div>
  );
};

export const isDarkTheme = (resellerID: number) => {
  switch (resellerID) {
    // dark theme resellers
    case Number(RESELLERIDS.OTTERA):
    case Number(RESELLERIDS.EVRIDEO):
    case Number(RESELLERIDS.ORKA):
      return true;
    default:
      return false;
  }
};

export const trackEvent = (eventTitle: SidebarEventTypes, user: IUserState) => {
  const is_super_user = hasRoleSuperUser(user.user);
  track(
    eventTitle,
    {
      is_super_user,
    },
    user.user,
  );
};
